import * as React from 'react';
import { ImportRetryErrorFeedback } from './import-error-feedback';
import { ImportValidationFeedback } from './import-validation-feedback';
import { FocusFile } from 'shared/file-importer/types';

interface ImportFeedbackProps {
    fileName: string;
    focusFile: FocusFile | undefined;
    isDuplicateFile: boolean;
    showDeleteError: boolean;
    showValidationFeedback: boolean;
}
export const ImportFeedback: React.FC<ImportFeedbackProps> = (props) => {
    const { fileName, focusFile, isDuplicateFile, showValidationFeedback, showDeleteError } = props;

    if (showDeleteError) {
        return <ImportRetryErrorFeedback />;
    }

    if (showValidationFeedback) {
        return <ImportValidationFeedback fileName={fileName} focusFile={focusFile} isDuplicateFile={isDuplicateFile} />;
    }

    return null;
};
